import adminAppealsSlice from "@features/admin/appeals/slice";
import adminBanksSlice from "@features/admin/banks/slice";
import adminCachesSlice from "@features/admin/caches/slice";
import adminBalancesSlice from "@features/admin/finance/slice";
import adminGeneralSlice from "@features/admin/general/slice";
import adminOrdersSlice from "@features/admin/order/slice";
import adminPayOutOrdersSlice from "@features/admin/payOut/slice";
import adminUsersSlice from "@features/admin/users/slice";
import adminWithdrawalsSlice from "@features/admin/withdrawals/slice";
import alertSlice from "@features/alert/slice";
import appealsSlice from "@features/appeals/slice";
import authReducer from "@features/auth/slice";
import balanceReducer from "@features/balance/slice";
import cashRegistersSlice from "@features/cash-registers/slice";
import devicesReducer from "@features/device/slice";
import merchantReducer from "@features/merchantBalance/slice";
import merchantOrdersSlice from "@features/merchantOrder/slice";
import notificationsSlice from "@features/notification/slice";
import ordersSlice from "@features/order/slice";
import requisitesSlice from "@features/requisite/slice";
import walletsSlice from "@features/wallets/slice";
import withdrawalsSlice from "@features/withdrawals/slice";
import payoutOrdersSlice from "@features/payouts/slice";
import merchantPayoutOrdersSlice from "@features/merchantPayout/slice";
import leadSlice from "@features/lead/slice";
import generalSlice from "@features/general/slice";
import { configureStore } from "@reduxjs/toolkit";
import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const store = configureStore({
  reducer: {
    general: generalSlice,
    auth: authReducer,
    device: devicesReducer,
    balance: balanceReducer,
    merchantBalance: merchantReducer,
    order: ordersSlice,
    merchantOrder: merchantOrdersSlice,
    withdrawals: withdrawalsSlice,
    cashRegisters: cashRegistersSlice,
    appeal: appealsSlice,
    requisite: requisitesSlice,
    notification: notificationsSlice,
    wallets: walletsSlice,
    payoutOrders: payoutOrdersSlice,
    merchantPayoutOrders: merchantPayoutOrdersSlice,
    adminBalances: adminBalancesSlice,
    adminOrders: adminOrdersSlice,
    adminPayOutOrders: adminPayOutOrdersSlice,
    adminWithdrawals: adminWithdrawalsSlice,
    adminUsers: adminUsersSlice,
    adminCaches: adminCachesSlice,
    adminBanks: adminBanksSlice,
    adminAppeals: adminAppealsSlice,
    adminGeneral: adminGeneralSlice,
    leadSlice: leadSlice,
    alert: alertSlice,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
